import {ROUTE_PARAMS_REGEX} from '@shared/constants/regexs.const';

export const getRouting = (route: string, params: string[]): string => {
  const matchedParams: string[] = route.match(ROUTE_PARAMS_REGEX) || [];

  if (!!matchedParams.length || !!params.length) {
    if (params.length === matchedParams.length) {
      for (let i = 0; i < params.length; i++) {
        route = route.replace(matchedParams[i], params[i]);
      }
    } else {
      throw new Error(`Niepoprawna liczba parametrów routingu ${params.length}/${matchedParams.length} dla adresu ${route}.`);
    }
  }
  return route;
};

export const getRoutingArray = (route: string, params: string[] = [], isAbsolute: boolean = true): string[] => {
  const base: string[] = [];
  const pathname: string[] = getRouting(route, params).split('/');

  if (isAbsolute) {
    base.push('/');
  }

  pathname.shift();
  return base.concat(pathname);
};
